// extracted by mini-css-extract-plugin
module.exports = {"block":"_15571","item":"_12809","value":"_5515"};